module.exports = __webpack_public_path__ + "img/puzzle2-600.461d7578.png";